import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import Header from "../common/headerlist";
import {
  Weightlist,
  WeightTotal,
  downLoadExcel,
  getPrivilegeExcel,
  getProductType,
  getProduct,
} from "../../services/wms";
import { trucklistgroup } from "../../services/wms";

// import { getProductType } from "../../services/wms/grabconcept";
// import { getProductType ,getProduct} from "../../services/wms";
import Showimage from "./modalshowimage";
import numberWithCommas from "../common/number";
import DatePicker from "react-datepicker";
import moment from "moment";
import BranchContext from "../context/branch";
import Input from "./input";
import Renderregister from "./renderweightlist";
import ScrollToTop from "../common/ScrollToTop";
import jsfiledownload from "js-file-download";
import { toast } from "react-toastify";

import Select from "./select";
const Registerlist = (props) => {
  // let datalink = props.location.linkdetails;
  // let cusId = 0;
  //console.log(datalink);
  // if (datalink) {
  //   cusId = datalink.cusid;
  // }
  const mainUrl =
    "https://wms.advanceagro.net/ws2/api/image/GetImageByWeightNo?weightno=";

  const { currentBranch } = useContext(BranchContext);
  const [productTypeId, setProductTypeId] = useState(0);
  const [productId, setProductId] = useState(0);
  const [register, setregister] = useState([]);
  const [truckid, setruckid] = useState(0);
  const [eventclick, seteventclick] = useState(false);
  // const [cusid, setCusid] = useState(cusId);
  const [search, setSearch] = useState("");
  // const [confirmsearch, setconfirmsearch] = useState("");
  const [name, setname] = useState("");
  const [startDate, setStartDate] = useState(new Date());

  const [amount, setamount] = useState(0);
  const [totalweight, settotalweight] = useState(0);
  const [totalweightin, settotalweightin] = useState(0);
  const [totalweightout, settotalweightout] = useState(0);
  const [totalweightcut, settotalweightcut] = useState(0);
  const [endDate, setEndDate] = useState(new Date());
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  //const [pageSize, setPageSize] = useState(25);
  const pageSize = 20;
  const [productType, setProductType] = useState([]);
  const [trucklist, settrucklist] = useState([]);
  const [product, setProduct] = useState([]);
  const [isDownload, setisDownload] = useState(true);
  const [chkDownload, setchkDownload] = useState(true);
  const [isOpen, setisOpen] = useState(false);
  // const [weightno, setweightno] = useState('')
  // const [camid, setcamid] = useState(0)
  // const [action, setaction] = useState('')
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;
    const loadData = async () => {
      const { data: result } = await getProductType(currentBranch._id);
      if (result) {
        setProductType(result);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;
    const loadData = async () => {
      const { data: result } = await getProduct(
        currentBranch._id,
        productTypeId
      );
      if (result) {
        setProduct(result);
      }
    };
    loadData();
  }, [currentBranch, productTypeId]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;

    const loadData = async () => {
      const { data: result } = await trucklistgroup(currentBranch._id);
      if (result) {
        settrucklist(result);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;
    const loadData = async () => {
      const { data: result } = await WeightTotal(
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        moment(endDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        currentBranch && currentBranch._id,
        productTypeId,
        productId,
        search
      );
      if (result.status === "success") {
        settotalweight(result.data.weightnet);
        settotalweightin(result.data.weightin);
        settotalweightout(result.data.weightout);
        settotalweightcut(result.data.weightcut);
        setamount(result.data.total);
      }
    };
    loadData();
  }, [startDate, endDate, search, currentBranch, productTypeId, productId]);

  useEffect(() => {
    setregister([]);
  }, [
    startDate,
    endDate,
    search,
    currentBranch,
    productTypeId,
    pageSize,
    productId,
  ]);
  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;
    setLoading(true);
    setError(false);
    const loadData = async () => {
      const { data: result } = await Weightlist(
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        moment(endDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        currentBranch && currentBranch._id,
        productTypeId,
        productId,
        search,
        pageSize,
        pageNumber
      );
      //console.log(result);
      if (result) {
        setisDownload(false);
        setregister((prevData) => {
          return [...new Set([...prevData, ...result])];
        });
        setHasMore(result.length > pageSize - 1);
        setLoading(false);
      }
    };
    loadData();
  }, [
    startDate,
    endDate,
    search,
    currentBranch,
    productTypeId,
    pageSize,
    pageNumber,
    productId,
  ]);

  const handleChangeTruck = ({ name, item, classname }) => {
    const clear = [...trucklist];

    const index1 = clear.findIndex((x) => x.classname === "btn btn-primary");
    if (index1 > -1) {
      clear[index1].classname = "btn btn-outline-dark";
      settrucklist(clear);
    }
    const subobject = {
      _id: item,
      name: name,
      classname: "btn btn-primary",
    };
    const sub = [...trucklist];
    const index = sub.findIndex((x) => x._id === item);
    sub[index] = subobject;
    settrucklist(sub);
    setruckid(item);
    seteventclick(false);
  };

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   if (currentBranch._id == "0" || currentBranch._id == "") return;
  //   if (!action) return;
  //   if (!weightno) return;
  //   if (!camid) return;
  //   if (!isOpen) return;

  //   const loadImageData = async () => {
  //     const { data : result } = await getImage(weightno,action,camid,currentBranch._id);
  //     if (result) {
  //       setImageUrl(result);
  //     }
  //   };
  //   loadImageData();
  // }, [currentBranch,weightno,action,camid,isOpen]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;
    const loadPrivilege = async () => {
      const { data: result } = await getPrivilegeExcel(currentBranch._id);
      if (result.status === "success") {
        setchkDownload(!result.data.result);
        //console.log(result.data.result)
      } else if (result.status === "error") {
        toast.error(result.message);
      }
    };
    loadPrivilege();
  }, [currentBranch]);

  const downloadReport = async () => {
    if (!currentBranch) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;

    try {
      if (register.length > 0) {
        if (isDownload) return;
        const output = await downLoadExcel(
          moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
          moment(endDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
          currentBranch._id,
          productTypeId,
          search,
          truckid
        );

        const { data: result, headers } = output;
        setisDownload(false);
        //console.log(result, headers);
        if (result.status === "error") {
          toast.error(result.message);
        } else {
          if (headers["x-suggested-filename"] === "nodata") {
            toast.error("No Report");
          } else {
            jsfiledownload(
              result,
              headers["x-suggested-filename"] || `report.xlsx`
            );
          }
        }
      } else {
        toast.error("Invalid Download Info");
      }
    } catch (err) {
      toast.error("ผิดพลาด " + err.message);
    }
  };

  const handleChangStartDate = (event) => {
    setStartDate(event);
    setPageNumber(1);
  };
  const handleChangEndDate = (event) => {
    setEndDate(event);
    setPageNumber(1);
  };
  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      // console.log('node = ' ,node);
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        //  console.log(entries[0].isIntersecting,hasMore);

        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const handleTextchange = (event) => {
    setname(event.target.value);
    // setPageNumber(1);
  };
  const handleChangeProductTypeID = (event) => {
    setProductTypeId(event.currentTarget.value);
    setPageNumber(1);
  };
  const handleChangeProductID = (event) => {
    setProductId(event.currentTarget.value);
    setPageNumber(1);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setSearch(name);
      setPageNumber(1);
    }
  };
  const handleSearchDrinvenClick = () => {
    setSearch(name);
    setPageNumber(1);
  };
  const handleImageClick = (weightno, action, id) => {
    setImageUrl(
      mainUrl +
        weightno +
        "&action=" +
        action +
        "&camid=" +
        id +
        "&branchid=" +
        currentBranch._id
    );
    setisOpen(true);
  };
  const handelClose = () => {
    setisOpen(false);
  };
  // console.log(imageUrl)

  return (
    <>
      <Showimage isOpen={isOpen} onCancel={handelClose} list={imageUrl} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-auto">
            <div className="m-2">
             <span className="p-0">
                จากวันที่
              </span>

              <div className="mt-2" style={{ marginTop: 20, marginBottom: 20 }}>
                <DatePicker
                  className="datepicker-default form-control"
                  todayButton="Today"
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={handleChangStartDate}
                />
              </div>
            </div>
          </div>
          <div className="col-auto">
            <div className="m-2">
             <span>
                ถึงวันที่
              </span>
              <div className="mt-2">
                <DatePicker
                  className="datepicker-default form-control"
                  todayButton="Today"
                  dateFormat="dd/MM/yyyy"
                  selected={endDate}
                  onChange={handleChangEndDate}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-sm-4 mt-2">
          <span className="m-2">
            ประเภทสินค้า
              </span>
            <div className="m-2">
           

              <Select
                data={productType}
                value={productTypeId}
                textProperty="type_name"
                valueProperty="Type_ID"
                onChange={handleChangeProductTypeID}
              />
            </div>
          </div>

          <div className="col-auto mt-2">
          <span className="m-2">
          ชื่อสินค้า
              </span>
            <div className="m-2">
              <Select
                data={product}
                value={productId}
                textProperty="ProductName"
                valueProperty="Product_ID"
                onChange={handleChangeProductID}
              />
            </div>
          </div>

          <div className="col-auto mt-2">
            <span >
              กลุ่มรถบรรทุก
            </span>

            <Header
              list={trucklist}
              onChange={handleChangeTruck}
              disabled={loading}
            />
          </div>
        </div>
      

      <div className="row">
        <div className="col-lg-3 col-sm-6 col-md-6 col-xs-12">
          <div className="form-group">
            <Input
              name="weightno"
              value={name}
              placeholder="ทะเบียนรถ เลขที่ใบชั่ง"
              onChange={handleTextchange}
              onKeyPress={handleKeyPress}
              onClick={handleSearchDrinvenClick}
              search="ค้นหา"
            />
          </div>
        </div>

        <div className="col-lg-6 col-sm-6 col-md-6 col-xs-12">
          <div>&nbsp;</div>
          <button
            onClick={downloadReport}
            disabled={chkDownload}
            className="btn btn-success "
          >
            Download To Excel
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col-auto mt-2">
          <p className="text-success">
            แสดงข้อมูล {register ? register.length : 0} รายการ
          </p>
        </div>

        <div className="col-auto mt-2">
          {"จำนวนเที่ยว"}{" "}
          <span
            className="badge rounded-pill bg-success"
            style={{ fontSize: "13px" }}
          >
            {numberWithCommas(amount)}
          </span>
        </div>
        <div className="col-auto mt-2">
          {"เข้า"}{" "}
          <span
            className="badge rounded-pill bg-info text-dark"
            style={{ fontSize: "13px" }}
          >
            {numberWithCommas(totalweightin)}
          </span>
          {"กก."}
        </div>
        <div className="col-auto mt-2">
          {"ออก"}{" "}
          <span
            className="badge rounded-pill bg-warning text-dark"
            style={{ fontSize: "13px" }}
          >
            {numberWithCommas(totalweightout)}
          </span>
          {"กก."}
        </div>
        <div className="col-auto mt-2">
          {"ตัด"}{" "}
          <span
            className="badge rounded-pill bg-danger"
            style={{ fontSize: "13px" }}
          >
            {numberWithCommas(totalweightcut)}
          </span>
          {"กก."}
        </div>

        <div className="col-auto mt-2">
          {"สุทธิ"}{" "}
          <span
            className="badge rounded-pill bg-success"
            style={{ fontSize: "13px" }}
          >
            {numberWithCommas(totalweight)}
          </span>
          {"กก."}
        </div>
      </div>

      {<ScrollToTop />}

      <Renderregister
        list={register}
        loading={loading}
        error={error}
        handleChange={handleImageClick}
        lastBookElementRef={lastBookElementRef}
      />

      <div>{loading && "Loading..."}</div>
      <div>{error && "Error"}</div>
      </div>
    </>
  );
};

export default Registerlist;
